import React from 'react';
import { MERGE_TAGS, insertAtCaret } from '../../lib/mergeTags.js';

/**
 * Row of clickable "available words". Clicking one inserts it at the cursor of the textarea
 * referenced by `textareaRef` (or at the end when it has no focus).
 * @param {{value: string, onChange: (v: string) => void, textareaRef: React.RefObject<HTMLTextAreaElement>, max?: number, testId?: string}} props
 */
export default function MergeTagChips({ value, onChange, textareaRef, max = 1600, testId = 'merge-tag-chips' }) {
  function insert(token) {
    const el = textareaRef?.current;
    const focused = el && typeof document !== 'undefined' && document.activeElement === el;
    const sel = el && focused ? { start: el.selectionStart, end: el.selectionEnd } : {};
    const { value: next, caret } = insertAtCaret(value, token, sel, max);
    onChange(next);
    if (el) requestAnimationFrame(() => { el.focus(); el.setSelectionRange(caret, caret); });
  }
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testId}>
      <span className="text-[10px] uppercase tracking-wide text-white/35">Available words:</span>
      {MERGE_TAGS.map((t) => (
        <button
          key={t.token}
          type="button"
          title={t.label}
          onMouseDown={(e) => e.preventDefault()} // keep the cursor in the text box
          onClick={() => insert(t.token)}
          className="px-2 py-0.5 rounded-sm bg-civix-purple/15 text-[11px] font-mono text-civix-purpleSoft hover:bg-civix-purple/30"
        >
          {t.token}
        </button>
      ))}
    </div>
  );
}
